"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _AccordionWorkflow = _interopRequireDefault(require("../AccordionWorkflow.context"));

var _AccordionWorkflowItem = require("./AccordionWorkflowItem.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AccordionWorkflowSummary = function AccordionWorkflowSummary(props) {
  var children = props.children,
      isHidden = props.isHidden;
  var context = (0, _react.useContext)(_AccordionWorkflow["default"]);

  if (!context) {
    throw new Error('<AccordionWorkflowSummary /> must be a child of <Accordion />');
  } // eslint-disable-next-line react/jsx-props-no-spreading


  return /*#__PURE__*/_react["default"].createElement(_AccordionWorkflowItem.StyledAccordionItemSummary, props, isHidden && /*#__PURE__*/_react["default"].createElement("div", null, children));
};

AccordionWorkflowSummary.propTypes = {
  /** Accordion item content. */
  children: _propTypes.node.isRequired,

  /** Controls whether of not the children are shown. */
  isHidden: _propTypes.bool.isRequired
};
AccordionWorkflowSummary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionWorkflowSummary",
  "props": {
    "children": {
      "description": "Accordion item content.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "isHidden": {
      "description": "Controls whether of not the children are shown.",
      "type": {
        "name": "bool"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(AccordionWorkflowSummary);

exports["default"] = _default;